import { Application } from '@/types/application';
import { Detail } from '@/types/detail';
import { Configuration, Metadata } from '@/types/metadata/metadata';
import { ValidationError, ValidationObject } from '@/types/validation';
import { isNumber, isObject } from '@/util/typeGuards';

export const semaphoreUtil = (): ValidationObject<number | undefined> => {
  const validate = (
    application: Application,
    metadata: Metadata,
    linkedSubroutineId: number,
    nodeId: number,
    blockName: string,
    configuration: Configuration,
    details: Detail
  ): ValidationError[] => {
    const errors: ValidationError[] = [];
    const value = getValue(configuration, details);
    if (configuration.required && value === undefined) {
      errors.push({
        severity: 'error',
        message: `Block ${blockName} is missing required Semaphore reference: ${configuration.label}`,
        id: nodeId
      });
    } else if (value !== undefined) {
      const foundSemaphore = application.semaphores?.find((semaphore) => semaphore.id === value);
      if (!foundSemaphore) {
        errors.push({
          severity: 'error',
          message: `Block ${blockName} refers to a Semaphore that doesn't exist.`,
          id: nodeId
        });
      }
    }
    return errors;
  };

  const getValue = (configuration: Configuration, obj: unknown): number | undefined => {
    if (!obj) return;
    const initVal = obj;
    if (isNumber(initVal)) {
      return initVal as number;
    } else if (isObject(obj)) {
      const prop = obj[configuration.value];
      return getValue(configuration, prop);
    }
    return;
  };

  return {
    validate: validate,
    getValue: getValue
  };
};
